module.exports = __webpack_public_path__ + "static/media/Handshake.40f3fe70.jpg";